import React from "react";

const ChatSettings = () => {
  return (
    <div>
      <h1>ChatSettings</h1>
    </div>
  );
};

export default ChatSettings;
